import { appConfig as getAppConfig } from "../../app.config";
import DetailsService from "../../services/DetailsService";

const getSizeFromAreaHA = (appConfig, area) => {
  const { mean, great } = appConfig.pointsSizes;
  if (area >= great) return "Grande";
  if (area >= mean) return "Medio";

  return "Pequeno";
};

const parsePropertiesToPrint = (appConfig, properties) => {
  const parsedProperties = {
    Município: properties.muni,
    Tamanho: properties.tamanho,
    ...appConfig.pointsProperties(properties),
  };

  const attributes = properties?.atributos?.split(";") ?? [];
  for (const attribute of attributes) {
    const [title, value] = attribute.split(":");
    parsedProperties[title] = value;
  }

  for (const [key, value] of Object.entries(parsedProperties)) {
    parsedProperties[key] = `${value}`;
  }

  return parsedProperties;
};

const parseProperties = (appConfig, properties) => {
  const parsedProperties = parsePropertiesToPrint(appConfig, properties);

  return Object.entries(parsedProperties)
    .map(([key, value]) => `<tr><td>${key}</td><td>${value}</td></tr>`)
    .join("\n");
};

const PointDetails = async ({ isOffline, content }) => {
  if (isOffline) {
    return `<div className="toggle">
                <p>Offline</p>
            </div>`;
  }

  try {
    const appConfig = await getAppConfig();
    content.features[0].properties.tamanho = getSizeFromAreaHA(
      appConfig,
      content.features[0].properties.area_ha
    );

    const location =
      content.features[0].id.split(".")[0] +
      "." +
      content.features[0].properties.unidade;

    content.features[0].properties.local = location;

    window.selectedAnnotationLocation = location;

    const properties = parseProperties(
      appConfig,
      content.features[0].properties
    );
    const propertiesToPrint = parsePropertiesToPrint(
      appConfig,
      content.features[0].properties
    );

    const printData = Buffer.from(
      JSON.stringify(propertiesToPrint, null, 0)
    ).toString("base64");

    const alreadyVisited = await DetailsService.detailsVisited(location);
    window.toggleAlreadyVisited(alreadyVisited);

    return `<div>
                <div class="toggle">
                  <label class="switch">
                    <input
                      type="checkbox"
                      onchange="window.toggleAlreadyVisited(event.target.checked);"
                      id="already-visited-toggle"
                      ${alreadyVisited ? "checked" : ""} />
                    <span class="slider round"></span>
                  </label>
                  <p>Já visitei</p>
                </div>

                <table class="point-details-table">
                  ${properties}
                </table>
                <br />
                <button title="Imprimir Detalhes" class="print-details" onclick="window.printDetails('${printData}');">🖨</button>
            </div>`;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default PointDetails;
